<div class="row mt-2">
    <div class="col-md-4">
        <label>{{label}}</label>
        <br/>
        <mat-radio-group #radioGroup
                         [value]="selection.selected[0]"
                         (change)="selection.select($event.value)">
            <mat-radio-button *ngFor="let option of options"
                              class="mr-3"
                              value="{{ option.value }}">
                {{ option.label }}
            </mat-radio-button>
        </mat-radio-group>
    </div>
</div>
